module.exports = __webpack_public_path__ + "img/map_right_bg.b8389ce8.png";